<template>
  <div class="ui basic segment">
    <div ref="preview_component"></div>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";
import filters from "@/filters";
import Vue from "vue";

export default {
  name: "VirtualPageViewerIndex",
  components: {},
  filters: filters,
  data() {
    return {
      page: {},
      vueObject: undefined,
    };
  },
  methods: {
    render(template) {
      let vm = this;
      let mixin = {};
      try {
        if (template.js) eval(`mixin = ${template.js}`);
      } catch (ex) {
        console.error(ex);
      }

      vm.vueObject = new Vue({
        template: template.html,
        mixins: [mixin],
        el: vm.$refs.preview_component,
        data: () => {
          return {};
        },
        methods: {
          locapi: local_api,
        },
        mounted: function() {
          let _vm = this;
          if (template.css) {
            setTimeout(() => {
              window.jQuery(_vm.$el).append(`<style>${template.css}</style>`);
            }, 200);
          }
        },
      });
    },
  },
  created() {},
  mounted() {
    let vm = this;
    let prototype_id = this.$route.query.m;
    let page_id = this.$route.query.p;
    local_api(vm, "post", "/prototype/viewer/do-get-page", {
      m: prototype_id,
      p: page_id,
    })
      .then((page) => {
        vm.page = page;
        vm.render(page.template);
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
};
</script>
